import Vue from 'vue';
import Notifications from 'vue-notification';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import sentryPlugin from './plugins/sentry';
import router from './router';
import store from './store';
import DefaultLayout from './layouts/Default';
import LoggedLayout from './layouts/Layout';
import './filters/dateFormatFromSettings';
import './filters/dateTimeFormatFromSettings';
import './styles/global.scss';
import 'cropperjs/dist/cropper.css';

Vue.use(Notifications);
Vue.component('default-layout', DefaultLayout);
Vue.component('logged-layout', LoggedLayout);

sentryPlugin(Vue);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
